// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"ce6aac4f06da640be716","551":"cf29730dbdd51ac055b8"}[chunkId] + ".css";
};